import gsap from "gsap";
import "./styles.scss";

class NavFullScreenService {
  constructor({ smoothScroll = undefined } = {}) {
    this.DOM = { fullscreennav: [document.querySelector("aside#full-screen-nav-modal")] };
    this.DOM.hamburgerButtons = [...document.querySelectorAll("[data-targetnav]")];
    this.DOM.closeNavButtons = [...document.querySelectorAll(".close-nav")];
    this.smoothScroll = smoothScroll;
    this.activeNav = undefined;
    this.addEvents();
  }

  setBodyUnscrollable = () => {
    if (this.smoothScroll) {
      gsap.set("body", { overflow: "hidden" });
      this.smoothScroll.pause();
    } else {
      this.scrolledTop = `-${window.scrollY}px`;
      gsap.set("body", {
        position: "fixed",
        top: this.scrolledTop,
      });
    }
  };
  setBodyScrollable = () => {
    if (this.smoothScroll) {
      gsap.set("body", { overflow: "" });
      this.smoothScroll.unpause();
    } else {
      gsap.set("body", {
        position: "",
        top: "",
      });
      window.scrollTo(0, parseInt(this.scrolledTop || "0") * -1);
    }
  };

  handleOpen = (e) => {
    this.activeNav = document.getElementById(e.currentTarget.dataset.targetnav);
    this.activeNavContent = this.activeNav.querySelector(".nav-content");

    this.setBodyUnscrollable();
    // accessibility
    this.activeNav.setAttribute("aria-modal", "true");
    this.activeNav.setAttribute("role", "dialog");
    this.scrollY = ""; // needed,when modal is hidden

    // Animation
    gsap
      .timeline({})
      .set(this.activeNav, { display: "block", y: -window.innerHeight })
      .set(this.activeNavContent, { display: "block", y: window.innerHeight })
      .to([this.activeNav, this.activeNavContent], { y: 0, duration: 2 });
  };

  handleEscapeKeyDown = (e) => {
    if (this.activeNav && e.key.toLowerCase() == "escape") {
      this.handleClose();
    }
  };

  handleClose = (e) => {
    // accessibility
    this.activeNav.removeAttribute("aria-modal");
    this.activeNav.removeAttribute("role");
    this.setBodyScrollable();
    //Animation
    gsap
      .timeline()
      .to(this.activeNav, { y: -window.innerHeight, duration: 0.75 })
      .to(this.activeNavContent, { y: window.innerHeight }, 0)
      .set(this.activeNav, { display: "none" });
    this.activeNav = undefined;
  };
  addEvents = () => {
    this.DOM.hamburgerButtons.forEach((btn) => btn.addEventListener("click", this.handleOpen));
    this.DOM.closeNavButtons.forEach((btn) => btn.addEventListener("click", this.handleClose));
    window.addEventListener("keydown", this.handleEscapeKeyDown);
  };
  removeEvents = () => {
    this.DOM.modalButtons.forEach((btn) => btn.removeEventListener("click", this.handleOpen));
    this.DOM.closeModalButtons.forEach((btn) => btn.removeEventListener("click", this.handleClose));
    window.removeEventListener("keydown", this.handleEscapeKeyDown);
  };
  destory = () => {
    reomoveEvents();
  };
}

export { NavFullScreenService };
